<template>
  <div class="register-container">
    <div class="title">
      <FloatingHeader :title="'Cadastro'" :sbtitle="'Preencha os campos abaixo'" :showHeader="true"
    :hideSearch="true" :routeToBack="'login'"></FloatingHeader>
    </div>
    <div class="required-fields">
      <p>Campos obrigatórios <span>(*)</span></p>
    </div>
    <div class="inputs-container">
      <div class="input-text" v-for="(input, key) in inputs" :key="key">
        <label :for="inputs.id" v-text="input.display"
          :class="{ 'has-error': input.hasError, disabled: input.disabled, 'required': input.required }"></label>
        <input v-if="input.mask" :class="{ 'has-error': input.hasError, disabled: input.disabled }"
          :disabled="input.disabled" :type="input.type" v-model="values[input.id]" v-mask="input.mask"
          @input="validateInput(input.id)"  :placeholder="input.mask"  />
        <input v-else :type="input.type" :disabled="input.disabled"
          :class="{ 'has-error': input.hasError, disabled: input.disabled }" v-model="values[input.id]"
          @input="validateInput(input.id)" />
        <span v-if="input.hasError" class="error-message">{{ input.message }}</span>
      </div>
    </div>
    <div class="submit-button">
      <DefaultButton :text="'Finalizar Cadastro'" :disabled="false" @defaultBtnClick="finish()" :large="true">
      </DefaultButton>
    </div>
  </div>
</template>

<script>
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import Util from '@/assets/libs/util'
import { validaCpfCnpj } from '@/assets/libs/cpfcnpj'
import { mapGetters } from 'vuex'
import FloatingHeader from '@/components/FloatingHeader.vue'
import { registerConsumer } from '@/assets/controllers/ConsumerController'

export default {
  name: 'RegisterView',
  components: {
    DefaultButton,
    FloatingHeader
  },
  data () {
    return {
      values: {
        name: '',
        email: '',
        senha: '',
        csenha: '',
        phone: '',
        cpf: '',
        cep: '',
        estado: '',
        cidade: '',
        bairro: '',
        logradouro: '',
        numero: '',
        complemento: ''
      },
      typeConsumer: null,
      idPlano: null,
      arrow_back: require('../../static/icons/arrow_back_white.svg')
    }
  },
  computed: {
    ...mapGetters(['inputs'])
  },
  created () {
    const queryParams = this.$route.query

    for (const key in queryParams) {
      if (Object.prototype.hasOwnProperty.call(this.values, key)) {
        this.values[key] = queryParams[key]
        this.validateInput(key)
      }
    }

    if (queryParams.consumerType) {
      this.typeConsumer = queryParams.consumerType
    }

    if (queryParams.idPlano) {
      this.idPlano = queryParams.idPlano
    }
  },
  methods: {
    async validateInput (id, findCep = true) {
      if (id === 'name') {
        this.values[id] = this.values[id] ? this.values[id].replace(/( )+/g, ' ') : ''
        if (!this.values[id] || this.values[id].length < 3) {
          this.inputs[0].hasError = true
        } else {
          this.inputs[0].hasError = false
        }
      }
      if (id === 'email') {
        this.values[id] = this.values[id] ? this.values[id].replace(/\s/g, '') : ''
        if (!this.values[id] || (this.values[id] && this.values[id].length < 5)) {
          this.inputs[1].hasError = true
        } else {
          this.inputs[1].hasError = false
        }
      }
      if (id === 'cep') {
        if (this.values[id] && this.values[id].length === 9) {
          if (findCep) {
            await Util.findCep(this.values[id]).then((e) => {
              this.values.cidade = e?.localidade || ''
              this.values.bairro = e?.bairro || ''
              this.values.estado = e?.estado || ''
              this.values.logradouro = e?.logradouro || ''
              this.inputs[6].hasError = false
            })
          }

          const fields = ['cidade', 'bairro', 'estado', 'logradouro']
          this.inputs.forEach(i => {
            if (fields.includes(i.id) && !this.values[i.id]) {
              i.disabled = false
            } else if (fields.includes(i.id) && this.values[i.id]) {
              if (findCep) {
                i.disabled = true
              }
              i.hasError = false
            }
          })
        } else {
          this.inputs[6].hasError = true
          this.inputs[6].message = 'CEP inválido'

          const fields = ['cidade', 'bairro', 'estado', 'logradouro']
          fields.forEach(f => {
            this.values[f] = ''
          })
        }
      }
      if (id === 'senha') {
        if (!this.values[id].length || this.values[id].length < 6) {
          this.inputs[2].hasError = true
          this.inputs[2].message = 'A senha deve conter 6 caracteres ou mais'
        } else {
          this.inputs[2].hasError = false
          this.inputs[2].message = ''

          if (this.values.csenha && this.values.csenha !== this.values.senha) {
            this.inputs[3].hasError = true
            this.inputs[3].message = 'As senhas não correspondem'
          } else {
            this.inputs[3].hasError = false
            this.inputs[3].message = ''
          }
        }
      }
      if (id === 'csenha') {
        if (!this.values[id] || this.values[id] !== this.values.senha) {
          this.inputs[3].hasError = true
          this.inputs[3].message = 'As senhas não correspondem'
        } else {
          this.inputs[3].hasError = false
          this.inputs[3].message = ''
        }
      }
      if (id === 'phone') {
        if (!this.values[id] || (this.values[id] && this.values[id].length < 15)) {
          this.inputs[4].hasError = true
        } else {
          this.inputs[4].hasError = false
        }
      }
      if (id === 'cpf') {
        if (!this.values[id] || (this.values[id] && !validaCpfCnpj(this.values[id]))) {
          this.inputs[5].hasError = true
        } else {
          this.inputs[5].hasError = false
        }
      }

      if (id === 'numero') {
        if (!this.values[id]) {
          this.inputs[11].hasError = true
          this.inputs[11].message = 'Campo obrigatório'
        } else {
          this.inputs[11].hasError = false
        }
      }

      const fields = ['cidade', 'bairro', 'estado', 'logradouro']
      if (fields.includes(id) && !this.values[id]) {
        this.inputs.forEach(i => {
          if (i.id === id) {
            i.hasError = true
            i.message = 'Campo obrigatório'
          } else if (i.id === id && this.values[i.id]) {
            i.hasError = false
          }
        })
      }
    },
    async finish () {
      let hasError = false
      this.inputs.forEach(async (e) => {
        await this.validateInput(e.id, false)
      })
      hasError = (this.inputs.findIndex(e => e.hasError === true) !== -1)
      if (!hasError) {
        this.callRegister()
      } else {
        Util.showWarningNotification({
          title: 'Atenção',
          text: 'Preencha todos os campos corretamente'
        })
      }
    },
    callRegister () {
      const data = {
        name: this.values.name,
        email: this.values.email,
        password: this.values.senha,
        cellphone: this.values.phone,
        cpf: this.values.cpf,
        address: {
          zipCode: this.values.cep,
          state: this.values.estado,
          city: this.values.cidade,
          neighborhood: this.values.bairro,
          street: this.values.logradouro,
          number: this.values.numero,
          complement: this.values.complemento
        }
      }

      if (this.typeConsumer) {
        data.typeConsumer = this.typeConsumer
      }

      if (this.idPlano) {
        data.idPlano = this.idPlano
      }

      registerConsumer(data).then((res) => {
        if (!res.error) {
          this.$router.push('/login')
          Util.showSuccessNotification({
            title: 'Sucesso',
            text: 'Cadastro realizado com sucesso'
          })
        } else {
          Util.showErrorNotification({
            title: 'Erro',
            text: res.message
          })
        }
      }).catch(() => {
        Util.showErrorNotification({
          title: 'Erro',
          text: 'Erro ao cadastrar, tente novamente'
        })
      })
    },
    goBack () {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped lang="less">
.register-container {
  padding: 65px 20px 170px 20px;

  .title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin: 10px 0;

    h1 {
      font-size: 18px;
      color: #9e9d9d;
    }

    button {
      position: absolute;
      left: 10px;
      border: none;
      height: 30px;
      width: 30px;
      background-color: white;
      color: black;

      img {
        filter: brightness(0.5);
        text-align: left;
        margin: 2px 0 0 0;
      }
    }
  }

  .required-fields {
    margin: 10px 0;

    p {
      font-size: 12px;
      color: #707070;

      span {
        color: var(--primaryColor);
      }
    }
  }

  .inputs-container {
    overflow: auto;

    .input-text {
      padding: 10px 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      label {
        font-size: 15px;
        padding-bottom: 5px;
        color: #707070;

        &.has-error {
          color: #d05f5f;
        }

        &.disabled {
          color: rgb(196, 196, 196);
        }

        &.required:after {
          content: '*';
          color: var(--primaryColor);
          margin-left: 5px;
        }
      }

      input {
        border: none;
        border-bottom: solid var(--primaryColor) 1px;
        width: -webkit-fill-available;
        height: 20px;
        font-size: 15px;

        &.has-error {
          border-bottom: solid var(--primaryColor) 1px;
        }

        &.disabled {
          border-bottom: solid rgb(196, 196, 196) 1px;
        }
      }

      input:focus {
        box-shadow: 0 1px 0 var(--primaryColor);
        outline: 0;

        &.has-error {
          box-shadow: 0 1px 0 var(--primaryColor);
        }
      }

      .error-message {
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }

  .submit-button {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    width: -webkit-fill-available;
    align-items: flex-start;
    justify-content: center;
    background: white;
    animation: upper-in 0.4s;
    padding: 35px 0 60px 0;
    filter: drop-shadow(2px 4px 6px black);

    button {
      color: white;
      background-color: var(--primaryColor);
      border: none;
      border-radius: 5px;
      height: 50px;
      width: 80vw;

      span {
        font-weight: lighter !important;
        font-size: 16px !important;
      }

      &.disabled {
        pointer-events: none;
        background-color: rgb(196, 196, 196);
      }
    }
  }
}
</style>
